import moment from 'moment'
import Mask from 'vanilla-masker'

export const getDefaultInitialValues = (list) => ({
  dsListName: list.dsListName,
  dtBegin: moment(list.dtBegin),
  dtEnd: moment(list.dtEnd),
  inAllBranchs: !!list.inAllBranchs,
  listRegionsAndBranchs: list.listRegionsAndBranchs.map((item) => ({
    label: item.dsBranchOrRegion,
    value: item.inRegion
      ? parseInt(item.idBranchOrRegion, 10)
      : item.idBranchOrRegion,
    isBranch: !item.inRegion,
  })),
  qtItemsInList: list.qtItemsInList,
  inTopZero: list.inTopZero,
  inTopOne: list.inTopOne,
  inTopTwo: list.inTopTwo,
})

export const getMoneyValue = (value) => {
  const isWholeNumber = value % 1 === 0
  return Mask.toMoney(isWholeNumber ? `${value}.00` : value || 0)
}
